import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const ProductCard = ({ product }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      to={`/product/${product.id}`}
      className="group block"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative overflow-hidden bg-gray-50 aspect-square mb-3 rounded-sm">
        <img
          src={product.image}
          alt={product.name}
          className={`w-full h-full object-cover transition-transform duration-500 ${
            isHovered ? 'scale-110' : 'scale-100'
          }`}
        />
      </div>
      <h3 className="text-sm font-normal text-gray-800 mb-1 group-hover:text-gray-600 transition-colors">
        {product.name}
      </h3>
      {product.specs && (
        <p className="text-xs text-gray-500 mb-1">{product.specs}</p>
      )}
      <p className="text-sm font-medium text-gray-900">
        {product.soldOut ? (
          <span className="text-red-600">SOLD OUT</span>
        ) : (
          `from $${product.price.toLocaleString()}.00`
        )}
      </p>
    </Link>
  );
};

const ProductGrid = ({ products, title, showButton = true }) => {
  const displayProducts = products.slice(0, 12);

  return (
    <section className="py-16">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-light text-center mb-12 text-gray-800">{title}</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-8">
          {displayProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
        {showButton && (
          <div className="text-center">
            <Button
              variant="outline"
              size="lg"
              className="border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white transition-all duration-300"
            >
              Shop More
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductGrid;